import { render, staticRenderFns } from "./SubjectCheck.vue?vue&type=template&id=6791f0c3&"
import script from "./SubjectCheck.vue?vue&type=script&lang=js&"
export * from "./SubjectCheck.vue?vue&type=script&lang=js&"
import style0 from "./SubjectCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports